export default __webpack_public_path__ + "static/media/366.ecabab73.jpg";